import Reflux from 'reflux';

const ClipbardActions = Reflux.createActions(['copy', 'paste']);

export default ClipbardActions;



// WEBPACK FOOTER //
// ./src/js/actions/Clipboard.js